import React from 'react';
import Seo from '../components/Seo';
import { Link } from 'react-router-dom';
import { Download, FileText, ArrowRight } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import { catalogs } from '../mock/mock';

const Catalogs = () => {
  const { toast } = useToast();

  const handleDownload = (title) => {
    toast({ title: 'Download requested', description: `${title}. Our team will email you the latest copy. (Demo)` });
  };

  return (
    <div>
      <Seo title="Catalogs & Brochures — Download" description="Download Kassam Trading Company product brochures and catalogs for rice, salt, wheat, corn and sesame — grades, packaging options and export specifications." path="/catalogs" />
      <PageHero
        title="Catalogs & Brochures"
        subtitle="Download our product catalogs, brochures and company profile with full specifications and packaging options."
        crumb="Catalogs"
      />

      <section className="max-w-6xl mx-auto px-6 py-20">
        <div className="grid sm:grid-cols-2 gap-6">
          {catalogs.map((c, i) => (
            <Reveal key={c.title} delay={(i % 2) * 80}>
              <div className="bg-ktc-ivoryLight rounded-xl border border-ktc-cream p-7 flex gap-5 card-lift h-full">
                <div className="h-16 w-14 shrink-0 grid place-items-center rounded-lg bg-ktc-green text-ktc-goldLight">
                  <FileText size={26} />
                </div>
                <div className="flex-1">
                  <h3 className="font-serif text-2xl font-semibold text-ktc-green">{c.title}</h3>
                  <p className="text-sm text-ktc-charcoal/70 mt-2">{c.desc}</p>
                  <div className="flex items-center gap-3 mt-4">
                    <span className="text-xs bg-ktc-cream/70 text-ktc-charcoal/70 px-2.5 py-1 rounded-full">{c.size}</span>
                    <span className="text-xs text-ktc-charcoal/50">{c.pages}</span>
                  </div>
                  <button onClick={() => handleDownload(c.title)} className="inline-flex items-center gap-2 text-ktc-green font-semibold text-sm mt-5 link-underline">
                    <Download size={16} /> Download PDF
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14 bg-ktc-green text-ktc-ivory rounded-2xl p-10 text-center">
          <h2 className="font-serif text-3xl font-semibold">Looking for something specific?</h2>
          <p className="text-ktc-ivory/75 mt-3 max-w-xl mx-auto">Request a tailored specification sheet or price list for your target market and packaging.</p>
          <Link to="/quote" className="inline-flex items-center gap-2 bg-ktc-gold hover:bg-ktc-goldLight text-ktc-greenDark font-semibold px-8 py-3.5 rounded-md mt-7 transition-colors">Request a Quote <ArrowRight size={18} /></Link>
        </Reveal>
      </section>
    </div>
  );
};

export default Catalogs;
